<template>
  <div class="mobile newalumni-directory-div">
    <div class="search">
      <van-search
        v-model="keywords"
        shape="round"
        @input="search"
        placeholder="搜索"
      />
    </div>
    <div class="newalumni-directory-main" v-if="dataList.length > 0">
      <div
        class="newalumni-directory-list"
        v-for="(item, index) in dataList"
        :key="'alumnidirectorylist' + index"
      >
        <div class="newalumni-directory-list-headtitle">
          {{ item.title || "" }}
        </div>
        <div class="newalumni-directory-list-content">
          <div
            class="newalumni-directory-list-item"
            v-for="(tempInfo, tempIndex) in item.alumniBooks"
            :key="'alumnidirectorylistitem' + tempIndex"
            @click="clickListItem(tempInfo)"
          >
            <DsfMobileTeasCell
              :headerUrl="tempInfo.photo || defaultImg"
              :title=" tempInfo.name || '&nbsp;' "
              cellShape="none"
              :border="true"
            >
              <DsfMobileTeasCellItem
                :value=" tempInfo.phone || '&nbsp;' "
              >
              </DsfMobileTeasCellItem>
              <DsfMobileTeasCellItem
                :value=" tempInfo.job || '暂无单位' "
              >
              </DsfMobileTeasCellItem>
            </DsfMobileTeasCell>
          </div>
        </div>
      </div>
    </div>
    <div class="alumni-directory-main" v-else>
      <van-empty description="暂无数据" />
    </div>
  </div>
</template>
<script>
export default dsf.component({
  name: "DsfMobileNewAlumniDirectory",
  ctrlCaption: "同学录(新)",
  mixins: [$mixins.control],
  components: {},
  design: {
    isMask: false,
  },
  data() {
    return {
      dataList: [],
      keywords: "",
      defaultImg: dsf.config.setting_public_user_default_header,
    };
  },
  props: {
    url: {
      type: String,
      default: "classes/getStuAlumniBookByClassId",
    },
  },
  created() {},
  mounted() {
    if (this.isDesign) {
      this.dataList = [
        {
          isTeacher: 1,
          alumniBooks: [
            {
              id: "4869183fbf0a4decbb23b40b4f9dfc17",
              name: "金",
              phone: "12345678910",
              photo: null,
              job: null,
            },
          ],
          title: "班主任",
        },
        {
          isTeacher: 0,
          alumniBooks: [
            {
              id: "58eadf81dbb64aab91c506b07219a8d5",
              name: "付雪梅111",
              phone: "12345678910",
              photo: null,
              job: null,
            },
          ],
          title: "第三小组",
        },
      ];
      this.$dispatch("design-width-change", "100%");
    } else {
      this.loadCurrentData();
    }
  },
  computed: {},
  methods: {
    search: _.debounce(function () {
      this.loadCurrentData();
    }, 300),
    loadCurrentData() {
      if (this.isDesign) {
        return;
      }
      const loading = dsf.layer.loading();
      let _this = this;
      this.$http
        .get(this.url, {
          keyWord: this.keywords,
        })
        .done((res) => {
          dsf.layer.closeLoading(loading);
          if (res.success) {
            _this.dataList = res.data || [];
          } else {
            dsf.layer.message(res.message || "请求失败", false);
          }
        })
        .error((err) => {
          dsf.layer.closeLoading(loading);
          dsf.layer.message(err.message || "出错了，请重试", false);
        });
    },
    clickListItem(itemObject){
      if (this.$listeners["clickListItem"]) {
        this.$dispatch("clickListItem", itemObject);
      }
    },
  },
});
</script>